var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreEssentialsGal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2003 14.8548L18.4731 6.58105L19.7466 7.85365L10.2003 17.4L4.47266 11.6724L5.74526 10.3998L10.2003 14.8548Z",
    fill: "#335CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreEssentialsGal);
export default __webpack_public_path__ + "static/media/core_essentials_gal.c52a39532222ab4f0be7c0b6ccdd019a.svg";
export { ForwardRef as ReactComponent };